import BaseTabComponent from "../../tabs-components/BaseTabComponent";

export function buildSummedDetailedInformation(tab) {
    return {
        hasNamesColumn: false,
        headerRow: [],
        rows: {
            'first-row': {
                valueCells: [
                    { // % of Sq Ft - 0
                        unit: '%',
                        type: 'number',
                        editable: false,
                        styleClasses: 'just-border-top bg-krem',
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const occupiedSqFt = tabs[tab].tables['sumed-general-information'].rows['first-row'].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'] ? tabs[tab].tables['sumed-general-information'].rows['first-row'].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'] : 0;
                            const totalSqFt = tabs[tab].tables['sumed-general-information'].rows['third-row'].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'] ? tabs[tab].tables['sumed-general-information'].rows['third-row'].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'] : 0;

                            let percent = 100.00;
                            if (totalSqFt !== 0) {
                                percent = parseFloat(occupiedSqFt / totalSqFt * 100);
                            }
                            return {internalValue: percent, displayValue: `(${percent.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}%)`};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'just-border-top bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    { // End - 2
                        unit: 'months',
                        type: 'number',
                        editable: tab === 'current-rr-tab',
                        highlightable: true,
                        highlightType: 'blue',
                        isHighlighted() {
                            return true;
                        },
                        styleClasses: 'just-border-top bg-krem',
                        // for current rr tab
                        value: '',
                        // for proforma rr tab
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    { // Current Monthly Rent - 3
                        unit: '$',
                        type: 'number',
                        editable: false,
                        styleClasses: 'just-border-top bold bg-krem',
                        getComputedValue(tabs) {
                            let sum = 0;
                            const rows = tabs[tab].tables['detailed-information'].rows;
                            Object.values(rows).forEach((row) => {
                                sum = row.valueCells[3].value ? sum + parseFloat(row.valueCells[3].value) : sum;
                            });
                            sum = parseFloat(sum);

                            return {internalValue: sum, displayValue: `$${sum.toLocaleString(undefined, {maximumFractionDigits: 2})}`};
                        },
                    },
                    { // Current Annual Rent - 4
                        unit: '$',
                        type: 'number',
                        editable: false,
                        styleClasses: 'just-border-top bold bg-krem',
                        getComputedValue(tabs) {
                            let sum = 0;
                            const rows = tabs[tab].tables['detailed-information'].rows;
                            Object.keys(rows).forEach((key) => {
                                sum = rows[key].valueCells[4].getComputedValue(tabs, key)['internalValue'] ? sum + parseFloat(rows[key].valueCells[4].getComputedValue(tabs, key)['internalValue']) : sum;
                            });
                            if (sum < 0) {
                                return {internalValue: -1, displayValue: `-`};
                            }

                            return {internalValue: sum, displayValue: `$${sum.toLocaleString(undefined, {maximumFractionDigits: 2})}`};
                        },
                    },
                    { // PSF - 5
                        unit: '$',
                        type: 'number',
                        editable: false,
                        styleClasses: 'just-border-top bold bg-krem',
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const crtAnnualRent = tabs[tab].tables['sumed-detailed-information'].rows['first-row'].valueCells[4].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'] ? tabs[tab].tables['sumed-detailed-information'].rows['first-row'].valueCells[4].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'] : 0;
                            const occupiedSqFt = tabs[tab].tables['sumed-general-information'].rows['first-row'].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'] ? tabs[tab].tables['sumed-general-information'].rows['first-row'].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'] : 0;
                            const totalSqft = tabs[tab].tables['sumed-general-information'].rows['third-row'].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'] ? tabs[tab].tables['sumed-general-information'].rows['third-row'].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'] : 0;
                            if (occupiedSqFt === 0) {
                                return {internalValue: -1, displayValue: `-`};
                            }

                            const value = tab == 'current-rr-tab' ? parseFloat(crtAnnualRent) / parseFloat(occupiedSqFt) : parseFloat(crtAnnualRent) / parseFloat(totalSqft);

                            return {internalValue: value, displayValue: `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`};
                        },
                    },
                    { // TI/SF - 6 (ProForma RR)
                        unit: '$',
                        type: 'number',
                        editable: false,
                        hidden: tab === 'current-rr-tab',
                        styleClasses: 'just-border-top bold bg-krem',
                        getComputedValue(tabs) {
                            const generalRows = tabs['proforma-rr-tab'].tables['general-information'].rows;
                            const detailedRows = tabs['proforma-rr-tab'].tables['detailed-information'].rows;
                            let sqftSum = 0, sum = 0;

                            Object.keys(generalRows).forEach(key => {
                                const tiSf = detailedRows[key].valueCells[6].value ? parseFloat(detailedRows[key].valueCells[6].value) : 0;
                                const sqft = generalRows[key].valueCells[2].value ? parseFloat(generalRows[key].valueCells[2].value) : 0;
                                if (sqft && tiSf) {
                                    sum = sum + tiSf * sqft;
                                }
                                if (sqft && tiSf > 0) {
                                    sqftSum = sqftSum + sqft;
                                }
                            });

                            if (sum <= 0 || sqftSum <= 0) {
                                return {internalValue: -1, displayValue: '-'};
                            }
                            const value = sum / sqftSum;
                            return {internalValue: value, displayValue: `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}/sf`};
                        },
                    },
                    { // LC - 7 (ProForma RR)
                        unit: '$',
                        type: 'number',
                        editable: false,
                        hidden: tab === 'current-rr-tab',
                        styleClasses: 'just-border-top bold bg-krem',
                        getComputedValue(tabs) {
                            const generalRows = tabs['proforma-rr-tab'].tables['general-information'].rows;
                            const detailedRows = tabs['proforma-rr-tab'].tables['detailed-information'].rows;
                            const lcTotal = tabs['proforma-rr-tab'].tables['sumed-detailed-information'].rows['first-row'].valueCells[9].getComputedValue(tabs).internalValue;
                            let sqftSum = 0;

                            Object.keys(generalRows).forEach(key => {
                                const lc = detailedRows[key].valueCells[7].value ? parseFloat(detailedRows[key].valueCells[7].value) : 0;
                                const sqft = generalRows[key].valueCells[2].value ? parseFloat(generalRows[key].valueCells[2].value) : 0;
                                if (sqft && lc > 0) {
                                    sqftSum = sqftSum + sqft;
                                }
                            });

                            if (lcTotal <= 0 || sqftSum <= 0) {
                                return {internalValue: -1, displayValue: '-'};
                            }
                            const value = lcTotal / sqftSum;
                            return {internalValue: value, displayValue: `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}/sf`};
                        },
                    },
                    { // TI Total - 8 (ProForma RR)
                        unit: '$',
                        type: 'number',
                        editable: false,
                        hidden: tab === 'current-rr-tab',
                        styleClasses: 'just-border-top bold bg-krem',
                        getComputedValue(tabs) {
                            let sum = 0;
                            const rows = tabs['proforma-rr-tab'].tables['detailed-information'].rows;
                            Object.keys(rows).forEach((key) => {
                                sum = rows[key].valueCells[8].getComputedValue(tabs, key).internalValue ? sum + parseFloat(rows[key].valueCells[8].getComputedValue(tabs, key).internalValue) : sum;
                            });
                            if (sum < 0) {
                                return {internalValue: -1, displayValue: `-`};
                            }

                            return {internalValue: sum, displayValue: `$${sum.toLocaleString(undefined, {maximumFractionDigits: 2})}`};
                        },
                    },
                    { // LC Total - 9 (ProForma RR)
                        unit: '$',
                        type: 'number',
                        editable: false,
                        hidden: tab === 'current-rr-tab',
                        styleClasses: 'just-border-top bold bg-krem',
                        getComputedValue(tabs) {
                            let sum = 0;
                            const rows = tabs['proforma-rr-tab'].tables['detailed-information'].rows;
                            Object.keys(rows).forEach((key) => {
                                sum = rows[key].valueCells[9].getComputedValue(tabs, key).internalValue ? sum + parseFloat(rows[key].valueCells[9].getComputedValue(tabs, key).internalValue) : sum;
                            });
                            if (sum < 0) {
                                return {internalValue: -1, displayValue: `-`};
                            }

                            return {internalValue: sum, displayValue: `$${sum.toLocaleString(undefined, {maximumFractionDigits: 2})}`};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'just-border-top bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'just-border-top bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'just-border-top bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'just-border-top bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    { // Annual effective rent - 14
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'just-border-top bold bg-krem',
                        getComputedValue(tabs) {
                            let sum = 0;
                            const rows = tabs[tab].tables['detailed-information'].rows;
                            Object.keys(rows).forEach((key) => {
                                sum = rows[key].valueCells[14].getComputedValue(tabs, key)['internalValue'] ? sum + parseFloat(rows[key].valueCells[14].getComputedValue(tabs, key)['internalValue']) : sum;
                            });
                            if (sum <= 0)
                                return {internalValue: 0, displayValue: '-'};
                            return {internalValue: sum, displayValue: `$${sum.toLocaleString(undefined, {maximumFractionDigits: 2})}`};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'just-border-top bold bg-krem',
                        getComputedValue(tabs) {
                            const detailAnnualRent = tabs[tab].tables['sumed-detailed-information'].rows['first-row'].valueCells[14].getComputedValue(tabs);
                            const generalSft = tabs[tab].tables['sumed-general-information'].rows['first-row'].valueCells[2].getComputedValue(tabs);
                            if(detailAnnualRent.internalValue && generalSft.internalValue){
                                let value = detailAnnualRent.internalValue / generalSft.internalValue; 
                                return {internalValue: value, displayValue:  `$${value.toLocaleString(undefined, {minimumFractionDigits:2, maximumFractionDigits: 2})}`};
                            }
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'just-border-top bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'just-border-top bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'just-border-top bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'just-border-top bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'just-border-top bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'just-border-top bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'number',
                        editable: false,
                        styleClasses: 'borderless bold',
                        getComputedValue(tabs) {
                            let sum = 0;
                            const rows = tabs[tab].tables['detailed-information'].rows;
                            Object.keys(rows).forEach((key) => {
                                sum = rows[key].valueCells[22].getComputedValue(tabs, key)['internalValue'] ? sum + parseFloat(rows[key].valueCells[22].getComputedValue(tabs, key)['internalValue']) : sum;
                            });

                            return {internalValue: sum, displayValue: `${sum.toLocaleString()}`};
                        },
                    }]
            },
            'second-row': {
                valueCells: [{ // % of Sq Ft - 0
                    unit: '%',
                    type: 'number',
                    editable: false,
                    styleClasses: 'borderless bg-krem',
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const vacantSqFt = tabs[tab].tables['sumed-general-information'].rows['second-row'].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'] ? tabs[tab].tables['sumed-general-information'].rows['second-row'].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'] : 0;
                        const totalSqFt = tabs[tab].tables['sumed-general-information'].rows['third-row'].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'] ? tabs[tab].tables['sumed-general-information'].rows['third-row'].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'] : 0;

                        let percent = 100.00;
                        if (totalSqFt !== 0) {
                            percent = parseFloat(vacantSqFt / totalSqFt * 100);
                        }

                        return {internalValue: percent, displayValue: `(${percent.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}%)`};
                    },
                },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'borderless bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    { // End - 2
                        unit: '%',
                        type: 'number',
                        editable: false,
                        highlightable: tab === 'current-rr-tab',
                        highlightType: tab === 'current-rr-tab' && 'pink',
                        isHighlighted(tabs) {
                            const detailedRows = tabs[tab].tables['detailed-information'].rows;
                            const precomputedValues = BaseTabComponent.precomputeHeavilyUsedValues(tabs);
                            let isHighlighted = false;
                            Object.keys(detailedRows).some(key => {
                                if (detailedRows[key].valueCells[2].isHighlighted(tabs, key, precomputedValues)) {
                                    isHighlighted = true;
                                    return;
                                }
                            });
                            return isHighlighted;
                        },
                        styleClasses: 'borderless bg-krem',
                        getComputedValue(tabs) {
                            if (tab === 'proforma-rr-tab') return {internalValue: '', displayValue: ''};
                            let sum = 0;
                            const rows = tabs[tab].tables['detailed-information'].rows;
                            Object.keys(rows).forEach((key) => {
                                if (rows[key].valueCells[2].isHighlighted(tabs, key)) {
                                    sum = rows[key].valueCells[0].getComputedValue(tabs, key)['internalValue'] ? sum + parseFloat(rows[key].valueCells[0].getComputedValue(tabs, key)['internalValue']) : sum;
                                }
                            });

                            sum = parseFloat(sum).toFixed(1);

                            return {internalValue: sum, displayValue: `${sum.toLocaleString()}% rollover`};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'borderless bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'borderless bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'borderless bg-krem',
                        getComputedValue() {
                            const value = tab ===' current-rr-tab' ? 'Ave/Space Occupied' : 'per occ. SF';
                            return {internalValue: value, displayValue: `${value.toLocaleString()}`};
                        },
                    },
                    { // TI/SF - 6 (ProForma RR)
                        unit: '%',
                        type: 'number',
                        editable: false,
                        hidden: tab === 'current-rr-tab',
                        styleClasses: 'borderless bg-krem',
                        getComputedValue(tabs) {
                            const tiTotal = tabs['proforma-rr-tab'].tables['sumed-detailed-information'].rows['first-row'].valueCells[8].getComputedValue(tabs).internalValue ? tabs['proforma-rr-tab'].tables['sumed-detailed-information'].rows['first-row'].valueCells[8].getComputedValue(tabs).internalValue : 0;
                            if (!tiTotal) {
                                return {internalValue: 0, displayValue: ''};
                            }
                            return {internalValue: tiTotal, displayValue: `$${tiTotal.toLocaleString()} total`};
                        },
                    },
                    { // LC - 7 (ProForma RR)
                        unit: '%',
                        type: 'number',
                        editable: false,
                        hidden: tab === 'current-rr-tab',
                        styleClasses: 'borderless bg-krem',
                        getComputedValue(tabs) {
                            const lcTotal = tabs['proforma-rr-tab'].tables['sumed-detailed-information'].rows['first-row'].valueCells[9].getComputedValue(tabs).internalValue ? tabs['proforma-rr-tab'].tables['sumed-detailed-information'].rows['first-row'].valueCells[9].getComputedValue(tabs).internalValue : 0;
                            if (!lcTotal) {
                                return {internalValue: 0, displayValue: ''};
                            }
                            return {internalValue: lcTotal, displayValue: `$${lcTotal.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})} total`};

                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        hidden: tab === 'current-rr-tab',
                        styleClasses: 'borderless bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        hidden: tab === 'current-rr-tab',
                        styleClasses: 'borderless bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'borderless bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'borderless bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'borderless bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'borderless bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'borderless bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'borderless bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'borderless bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'borderless bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'borderless bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'borderless bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'borderless bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'borderless bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    }]
            },
            'third-row': {
                valueCells: [{
                    unit: '%',
                    type: 'number',
                    editable: false,
                    styleClasses: 'borderless bold bg-krem',
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const vacantSqFtPerc = tabs[tab].tables['sumed-detailed-information'].rows['second-row'].valueCells[0].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'] ? tabs[tab].tables['sumed-detailed-information'].rows['second-row'].valueCells[0].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'] : 0;
                        const occupiedSqFtPerc = tabs[tab].tables['sumed-detailed-information'].rows['first-row'].valueCells[0].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'] ? tabs[tab].tables['sumed-detailed-information'].rows['first-row'].valueCells[0].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'] : 0;
                        const sumPerc = Math.min(parseFloat(vacantSqFtPerc) + parseFloat(occupiedSqFtPerc), 100);

                        return {
                            internalValue: sumPerc,
                            displayValue: `(${sumPerc.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}%)`
                        };
                    },
                },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'borderless bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'borderless bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'borderless bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'borderless bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'borderless bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        hidden: tab === 'current-rr-tab',
                        styleClasses: 'borderless bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        hidden: tab === 'current-rr-tab',
                        styleClasses: 'borderless bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        hidden: tab === 'current-rr-tab',
                        styleClasses: 'borderless bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        hidden: tab === 'current-rr-tab',
                        styleClasses: 'borderless bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'borderless bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'borderless bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'borderless bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'borderless bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'borderless bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'borderless bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'borderless bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'borderless bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'borderless bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'borderless bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'borderless bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'borderless bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    }]
            },
            'fourth-row': {
                valueCells: [{
                    unit: '',
                    type: 'text',
                    editable: false,
                    styleClasses: 'just-border-bottom bg-krem',
                    getComputedValue() {
                        return {internalValue: '', displayValue: ''};
                    },
                },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'just-border-bottom bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'number',
                        editable: false,
                        highlightable: true,
                        highlightType: 'blue',
                        isHighlighted() {
                            return true;
                        },
                        styleClasses: 'just-border-bottom underlined bold bg-krem',
                        getComputedValue(tabs) {
                            if (tab === 'proforma-rr-tab') return {internalValue: '', displayValue: ''};
                            let sum = 0;
                            const rows = tabs[tab].tables['detailed-information'].rows;
                            Object.keys(rows).forEach((key) => {
                                let firstTerm = rows[key].valueCells[0].getComputedValue(tabs, key)['internalValue'] ? parseFloat(rows[key].valueCells[0].getComputedValue(tabs, key)['internalValue']) : 0;
                                let secondTerm = rows[key].valueCells[22].getComputedValue(tabs, key)['internalValue'] ? parseFloat(rows[key].valueCells[22].getComputedValue(tabs, key)['internalValue']) : 0;
                                sum += firstTerm * secondTerm;
                            });
                            sum = parseFloat(sum / 365 / 100).toFixed(1);

                            return {internalValue: sum, displayValue: `${sum.toLocaleString()} Years`};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: tab === 'current-rr-tab',
                        highlightable: true,
                        highlightType: 'blue',
                        isHighlighted() {
                            return true;
                        },
                        styleClasses: 'just-border-bottom bold bg-krem',
                        // for current rr tab
                        value: '',
                        // for proforma rr tab
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'just-border-bottom bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'just-border-bottom bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        hidden: tab === 'current-rr-tab',
                        styleClasses: 'borderless bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        hidden: tab === 'current-rr-tab',
                        styleClasses: 'borderless bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        hidden: tab === 'current-rr-tab',
                        styleClasses: 'borderless bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        hidden: tab === 'current-rr-tab',
                        styleClasses: 'borderless bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'just-border-bottom bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'just-border-bottom bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'just-border-bottom bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'just-border-bottom bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'just-border-bottom bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'just-border-bottom bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'just-border-bottom bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'just-border-bottom bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'just-border-bottom bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'just-border-bottom bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'just-border-bottom bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'just-border-bottom bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    }]
            },
        },
    };
}
